<template></template>

<script>
import storageService from "../services/storageService";
import { USER_CONFIG } from "../config/UserConfig";

export default {
  name: "ssoPage",
  data() {
    return {
      isValid: false,
      formularioId: "",
      codigoCliente: "",
    };
  },
  mounted() {
    console.log("está valido", this.isValid);
    if (this.isValid) {
      const { codigoCliente, formularioId } = this;
      this.$store.dispatch("definirFormularioComoAssistido", true);
      this.$router.push({
        name: "responderFormulario",
        params: { formularioId, codigoCliente },
      });
      //  path: '/responder/formulario/:formularioId/cliente/:codigoCliente',
    }
  },
  methods: {
    isValidData(str) {
      if (str === "" || str.trim() === "") {
        return { isValid: false };
      }
      try {
        const decodedData = atob(str);
        const data = btoa(decodedData);
        const isValid = data == str;
        let parsedData = "";
        if (isValid) {
          parsedData = decodedData;
        }

        return { isValid, parsedData };
      } catch (err) {
        return { isValid: false };
      }
    },
  },
  beforeMount() {
    storageService.clear();
    const { data: pessoa, codigoCliente, formularioId } = this.$route.params;
    const validData = this.isValidData(pessoa);
    if (pessoa && validData.isValid) {
      try {
        console.log("dados pessoa", validData.parsedData);
        const pessoa = JSON.parse(validData.parsedData);
        storageService.setJsonItem(USER_CONFIG.loggedUser, pessoa);
        this.isValid = true;
        this.codigoCliente = codigoCliente;
        this.formularioId = formularioId;
      } catch (error) {
        console.error(error);
        this.isValid = false;
      }
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/View/SsoPage.vue